import { APIHelper } from '@/services/axios';

const signin = reservation_code =>
  APIHelper.get(`/appointments/${reservation_code}`);

const signup = data => APIHelper.post('/auth/register', data);

const getBrands = () => APIHelper.get('/brands');

const getBrandModels = brand_id => APIHelper.get(`/brands/${brand_id}/models`);

const getMileages = () => APIHelper.get('/mileage');

const getModelsId = () => APIHelper.get('/models');

export { signin, signup, getBrands, getBrandModels, getMileages, getModelsId };
